import { c as _c } from "react/compiler-runtime";
import { useInfiniteQuery } from "@tanstack/react-query";
import { commonApiFetch } from "@/services/api/common-api";
import type { ApiWaveDecision } from "@/generated/models/ApiWaveDecision";
import type { ApiWaveDecisionsPage } from "@/generated/models/ApiWaveDecisionsPage";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { useMemo } from "react";
interface UseWaveSalesDecisionsProps {
  readonly waveId: string;
  readonly enabled?: boolean | undefined;
}
const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 100;
const DEFAULT_STALE_TIME = 60000;
const sortDecisionPoint = (decisionPoint: ApiWaveDecision): ApiWaveDecision => ({
  ...decisionPoint,
  winners: [...decisionPoint.winners].sort((a, b) => a.place - b.place)
});
export function useWaveSalesDecisions(t0) {
  const $ = _c(18);
  const {
    waveId,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  let t2;
  let t3;
  if ($[0] !== waveId) {
    t2 = [QueryKey.WAVE_DECISIONS_SALES, {
      waveId
    }];
    t3 = async t4 => {
      const {
        pageParam
      } = t4;
      const currentPage = pageParam ?? DEFAULT_PAGE;
      return await commonApiFetch({
        endpoint: `waves/${waveId}/decisions`,
        params: {
          sort_direction: "DESC",
          sort: "decision_time",
          page: currentPage.toString(),
          page_size: DEFAULT_PAGE_SIZE.toString()
        }
      });
    };
    $[0] = waveId;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== enabled || $[4] !== t2 || $[5] !== t3) {
    t4 = {
      queryKey: t2,
      queryFn: t3,
      initialPageParam: DEFAULT_PAGE,
      getNextPageParam: _temp,
      enabled,
      staleTime: DEFAULT_STALE_TIME
    };
    $[3] = enabled;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    data,
    isError,
    error,
    refetch,
    isFetching,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage
  } = useInfiniteQuery(t4);
  data?.pages;
  let t5;
  if ($[7] !== data?.pages) {
    const mergedDecisionPoints = [];
    const seenDecisionTimes = new Set();
    for (const page of data?.pages ?? []) {
      for (const decisionPoint of page.data) {
        if (seenDecisionTimes.has(decisionPoint.decision_time)) {
          continue;
        }
        seenDecisionTimes.add(decisionPoint.decision_time);
        mergedDecisionPoints.push(sortDecisionPoint(decisionPoint));
      }
    }
    t5 = mergedDecisionPoints.sort(_temp2);
    $[7] = data?.pages;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const decisionPoints = t5;
  let t6;
  if ($[9] !== decisionPoints || $[10] !== error || $[11] !== fetchNextPage || $[12] !== hasNextPage || $[13] !== isError || $[14] !== isFetching || $[15] !== isFetchingNextPage || $[16] !== refetch) {
    t6 = {
      decisionPoints,
      isError,
      error,
      refetch,
      isFetching,
      fetchNextPage,
      hasNextPage,
      isFetchingNextPage
    };
    $[9] = decisionPoints;
    $[10] = error;
    $[11] = fetchNextPage;
    $[12] = hasNextPage;
    $[13] = isError;
    $[14] = isFetching;
    $[15] = isFetchingNextPage;
    $[16] = refetch;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}
function _temp2(a, b) {
  return a.decision_time - b.decision_time;
}
function _temp(lastPage) {
  return lastPage.next ? lastPage.page + 1 : undefined;
}